<template>
  <div id="system-database-add">
    <ipub-model :title="params.id?'Edit Announcement':'Add Announcement'"
                width="900px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="database-add-form"
                 :model="params"
                 autocomplete="off"
                 :rules="rules">
        <ipub-form-item prop="name"
                        label="Title">
          <ipub-input placeholder="Title"
                      v-model.trim="params.name" />
        </ipub-form-item>
        <ipub-form-item prop="firstReleaseTime"
                        label="Publish Date">
          <ipub-date-picker placeholder="Choose Publish Date"
                            v-model="params.firstReleaseTime" />
        </ipub-form-item>
        <ipub-form-item prop="linked"
                        label="Links">
          <ipub-radio-group class="mar-b-10"
                            v-model="params.linked"
                            @change="onLinkedChange"
                            _label="name"
                            :options="[{name:'Yes',value:true},{name:'No',value:false}]" />
          <ipub-input v-if="params.linked"
                      placeholder="Enter link here"
                      v-model.trim="params.linkAddress" />
          <ipub-editor v-else
                       :height="200"
                       v-model.trim="params.linkText" />
        </ipub-form-item>
        <ipub-row :gutter="20"
                  v-if="!params.linked">
          <ipub-col :span="12">
            <ipub-form-item prop="file"
                            label="Upload File (PDF, word or ZIP)">
              <ipub-upload-input :file="params"
                                 _name="announcementName"
                                 _path="announcement"
                                 class="mar-b-20"
                                 :loading="loading"
                                 :domain="domain"
                                 @delete="del"
                                 @change="(e)=>{handleUpload('announcement',e)}" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
      </ipub-form>
      <div slot="footer">
        <ipub-button plain
                     type="primary"
                     :style="{minWidth: '150px'}"
                     @click="cancel">Cancel</ipub-button>
        <ipub-button plain
                     v-if="!params.id"
                     type="primary"
                     :style="{minWidth: '150px'}"
                     @click="confirm(false)">Save as Draft</ipub-button>
        <ipub-button type="primary"
                     :style="{minWidth: '150px'}"
                     @click="confirm(true)">Publish</ipub-button>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import announcement from '@/api/announcement'
import check from '@/utils/check'
import { getUploadConfig } from '@/utils/upload'
import help from '@/utils/help'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      params: {
        linked: true,
      },
      loading: false,
      rules: {},
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
      publisherId: 'getPublisherId',
      domain: 'getDomain'
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          linked: true,
        }

      } else {
        if (this.inputData.id) {
          this.getQuery(this.inputData.id)
        } else {
          this.params = {
            linked: true,

          }
        }

      }
    }
  },
  mounted () {
    this.getRules()
    help.closeAutocomplete()
  },
  methods: {
    async getQuery (id) {
      this.params = await announcement.query(id)
    },
    async confirm (val) {
      if (this.params.linked) {
        if (!this.params.linkAddress || !check.website(this.params.linkAddress)) {
          this.$message.error({ title: 'Error', content: this.LANGUAGE[this.language].enterCorrent + 'Link' })
          return
        }
      }
      const flag = this.$refs['database-add-form'].validate()
      if (flag) {
        const data = Object.assign(this.params, {
          released: val,
          journalId: this.journalId
        })
        if (this.params.id) {
          await announcement.edit(this.params.id, data)
          this.$message.success({ title: 'Success', content: 'This Announcement has been published!' })
        } else {
          await announcement.add(data)
          if (val) {
            this.$message.success({ title: 'Success', content: 'This Announcement has been published!' })
          } else {
            this.$message.success({ title: 'Success', content: 'This Announcement has been saved!' })
          }
        }
        this.$emit('confirm', data)
      }
    },
    onLinkedChange () {
      this.params.linkAddress = ''
      this.params.linkText = ''
    },
    preview () {

    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        name: [
          {
            required: true,
            message:
              'Title' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        linked: [
          {
            required: true,
            message:
              'Link' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        firstReleaseTime: [
          {
            required: true,
            message:
              'Publish Date' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
      }
    },
    async handleUpload (key, files) {
      const file = files[0]
      const types = ['pdf', 'docx', 'doc', 'txt', 'zip',]
      const type = file.name.split('.')
      if (!types.includes(type[type.length - 1])) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }

      const MS = 30
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }

      const path = `publisher/${this.publisherId}/journal/${this.journalId}/announcement/${help.guid()}`

      this.loading = true
      const url = await getUploadConfig(file, path)

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }
      this.loading = false
      this.$set(this.params, key + 'Name', file.name)
      this.$set(this.params, key, url)
      // console.log(this.params, '上传文件')
    },
    del () {
      this.$confirm({
        title: 'Are you sure you want to delete this file?',
        content:
          'Please be aware of once this file is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        this.params.file = ''
        this.params.fileName = ''
        this.$message.success({
          title: 'Success',
          content: 'This file has been deleted!'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#system-database-add {
  .upload-content {
    height: 77px;
    width: 253px;
    background: $content_color;
    border: 1px solid $border_color;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .file-content {
    width: 84%;
    height: 40px;
    margin-right: 15px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #d9dfe2;
    line-height: 40px;
    padding: 0 12px;
  }
}
</style>
